import { render, staticRenderFns } from "./ModalContentShowItemPreview.vue?vue&type=template&id=534f7652"
import script from "./ModalContentShowItemPreview.vue?vue&type=script&lang=js"
export * from "./ModalContentShowItemPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534f7652')) {
      api.createRecord('534f7652', component.options)
    } else {
      api.reload('534f7652', component.options)
    }
    module.hot.accept("./ModalContentShowItemPreview.vue?vue&type=template&id=534f7652", function () {
      api.rerender('534f7652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/modalContent/ModalContentShowItemPreview.vue"
export default component.exports